import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.is-array";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.map";
import "core-js/modules/es.date.to-string";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.create";
import "core-js/modules/es.object.define-property";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.reflect.construct";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
 * Copyright (c) 2018 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author:
 *
 *Description:
 */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import WFCmsContainer from './WFCmsContainer';
import { DynamicSplash, AppInsertionPoint, SSPdfPackage } from './templates';
import CmsContext from './utils/CmsContext';
import { renderCmsComponent } from './utils/index';
import './Cms.less';
import ErrorBoundary from './utils/ErrorBoundary';
export var cmsTemplateMap = {
  securesitejump: DynamicSplash,
  splash: DynamicSplash,
  dynamicsplash: DynamicSplash,
  appinsertionpoint: AppInsertionPoint,
  sspdfpackage: SSPdfPackage
};
export var WFCmsRenderer = /*#__PURE__*/function (_PureComponent) {
  _inherits(WFCmsRenderer, _PureComponent);

  var _super = _createSuper(WFCmsRenderer);

  function WFCmsRenderer() {
    var _this;

    _classCallCheck(this, WFCmsRenderer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "getNumberedFootnotes", function (footnotes) {
      return footnotes.filter(function (_ref) {
        var schema = _ref.component.schema;
        return schema === 'Footnote';
      });
    });

    return _this;
  }

  _createClass(WFCmsRenderer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          id = _this$props.id,
          cmsData = _this$props.cmsData,
          parseJson = _this$props.parseJson,
          setIndividualComponentData = _this$props.setIndividualComponentData,
          _this$props$includeCo = _this$props.includeComponents,
          includeComponents = _this$props$includeCo === void 0 ? {} : _this$props$includeCo,
          setIncludeComponents = _this$props.setIncludeComponents;

      if (id && cmsData) {
        setIndividualComponentData(id, _defineProperty({}, id, cmsData), parseJson);
        setIncludeComponents(includeComponents);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          data = _this$props2.data,
          isFetching = _this$props2.isFetching,
          id = _this$props2.id,
          templateType = _this$props2.templateType;

      if (data && data.size && !isFetching) {
        var cmsTemplateData = data.toJS();
        var template = cmsTemplateData.pageTemplate && cmsTemplateData.pageTemplate.title || '';
        var CmsTemplate = cmsTemplateMap[template];
        var footnotes = cmsTemplateData.regions && cmsTemplateData.regions.footnote || [];
        var contexts = [{
          name: 'references',
          value: cmsTemplateData.references
        }, {
          name: 'footnotes',
          value: this.getNumberedFootnotes(footnotes)
        }, {
          name: 'id',
          value: id
        }, {
          name: 'templateType',
          value: templateType
        }];
        return cmsTemplateData ? /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(CmsContext.Providers, {
          contexts: contexts
        }, CmsTemplate ? /*#__PURE__*/React.createElement(CmsTemplate, _extends({
          className: "coreCms"
        }, cmsTemplateData, {
          id: id,
          templateType: templateType
        })) : renderCmsComponent(cmsTemplateData, id))) : null;
      }

      return null;
    }
  }]);

  return WFCmsRenderer;
}(PureComponent);
WFCmsRenderer.propTypes = {
  id: PropTypes.string.isRequired,
  data: PropTypes.object,
  isFetching: PropTypes.bool,
  setIndividualComponentData: PropTypes.func,
  parseJson: PropTypes.bool,
  cmsData: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  templateType: PropTypes.oneOf(['SERVICE', 'MARKETING', 'NOTIFICATION'])
};
export var withMultiCmsIds = function withMultiCmsIds(WrappedWFCmsRenderer) {
  var WithMultiCmsIds = /*#__PURE__*/function (_React$Component) {
    _inherits(WithMultiCmsIds, _React$Component);

    var _super2 = _createSuper(WithMultiCmsIds);

    function WithMultiCmsIds() {
      _classCallCheck(this, WithMultiCmsIds);

      return _super2.apply(this, arguments);
    }

    _createClass(WithMultiCmsIds, [{
      key: "render",
      value: function render() {
        var _this$props3 = this.props,
            _this$props3$cmsIds = _this$props3.cmsIds,
            cmsIds = _this$props3$cmsIds === void 0 ? [] : _this$props3$cmsIds,
            id = _this$props3.id,
            restProps = _objectWithoutProperties(_this$props3, ["cmsIds", "id"]);

        if (cmsIds && Array.isArray(cmsIds) && cmsIds.length) {
          return cmsIds.map(function (cmsId) {
            return /*#__PURE__*/React.createElement(WrappedWFCmsRenderer, _extends({
              id: cmsId,
              key: cmsId
            }, restProps));
          });
        } else {
          return /*#__PURE__*/React.createElement(WrappedWFCmsRenderer, _extends({
            id: id
          }, restProps));
        }
      }
    }]);

    return WithMultiCmsIds;
  }(React.Component);

  WithMultiCmsIds.propTypes = {
    cmsIds: PropTypes.array
  };
  return WithMultiCmsIds;
};
export default compose(withMultiCmsIds, WFCmsContainer)(WFCmsRenderer);